type ToastType = "success" | "info" | "warn" | "error";
interface ToastBase {
  severity?: ToastType;
  summary?: string;
  detail?: string;
  closable?: boolean;
  life?: number;
  styleClass?: string;
  contentStyleClas?: string;
}

export class ToastFactory {
  public static success = (message: string, title = "Sucesso", life = 3000) =>
    ToastFactory.factory("success", message, title, life);
  public static info = (message: string, title = "informação", life = 3000) =>
    ToastFactory.factory("info", message, title, life);
  public static warn = (message: string, title = "Alerta", life = 3000) =>
    ToastFactory.factory("warn", message, title, life);
  public static error = (message: string, title = "Erro", life = 3000) =>
    ToastFactory.factory("error", message, title, life);

  static factory(
    type: ToastType,
    title: string,
    message: string,
    life = 3000
  ): ToastBase {
    return {
      severity: type,
      summary: title,
      detail: message,
      life,
    };
  }
}
